var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNatsOnlineFlightmarkWhiteRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NATS_Grad",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 48",
    enableBackground: "new 0 0 200 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "S_grad_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.23703,
    y1: 39.135704,
    x2: 150.1455994,
    y2: 39.135704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0681453,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2553155
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "S_grad_1_",
    fill: "url(#S_grad_2_)",
    d: "M187.680542,33.7345657 c-0.7000885-0.8608627-1.6320343-1.634552-2.7795868-2.3004684c1.2174683,0.7145081,1.7522888,1.5960732,1.7522888,2.6761589 c0,3.1655617-2.7783356,4.845089-7.9459686,4.845089h-28.7484589l-2.0677338,7.8819695h32.430954 c5.0388641-0.6465721,8.9149933-4.5866623,8.9149933-8.8509293C189.23703,36.4325523,188.7032013,34.9921837,187.680542,33.7345657z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "S_solid_1_",
    fill: "#FFFFFF",
    d: "M178.9649811,1.6152073c-10.8530121,0-17.2481842,4.9739223-17.2481842,13.436821 c0,5.4269333,2.7126617,8.5275898,9.6255646,11.1122971l11.1114044,4.1345978 c0.7735138,0.2824516,1.4848785,0.601593,2.1320343,0.9537354c0.1082001,0.0588856,0.2105713,0.1207275,0.315155,0.1814384 c1.1475525,0.6659164,2.0794983,1.4396057,2.7795868,2.3004684c1.0226593,1.257618,1.556488,2.6979866,1.556488,4.2518196 c0,4.264267-3.8761292,8.2043571-8.9149933,8.8509293c10.2072906-0.4520645,15.8279266-5.4917717,15.8279266-14.3418961 c0-4.9099255-3.0368042-8.075491-10.3369598-10.8537922l-8.721283-3.2943974 c-4.651535-1.7443981-5.8790741-2.7783022-5.8790741-4.8451633c0-2.5846348,2.3253326-4.005765,6.718399-4.005765h16.2159424 c2.5847015,0,4.0706329-1.0330296,4.651535-3.2295251l1.2275391-4.6515684H178.9649811z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T_grad_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6675415,
    y1: 11.6243105,
    x2: 114.8184052,
    y2: 0.164411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644549,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2679794,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2553155
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "T_grad_1_",
    fill: "url(#T_grad_2_)",
    d: "M139.3701172,1.6152073h-28.424324l-2.0029297,7.8810935h20.1560745 C130.5410156,4.0658627,133.7504272,1.6152073,139.3701172,1.6152073z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "T_solid_1_",
    fill: "#FFFFFF",
    d: "M139.3701172,1.6152251c-5.6197052,0-8.8290863,2.4506648-10.2711639,7.8810749 l-9.7552109,37.3410339h6.8480453c2.3253326,0,3.5528564-0.9690514,4.1994629-3.4888916l8.8501282-33.8521423h14.6651459 c2.5837097,0,4.0697327-1.0330219,4.6514587-3.229516l1.2266541-4.6515589H139.3701172z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A_grad_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.4256134,
    y1: 5.2384939,
    x2: 62.2367058,
    y2: 46.8492928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0681453,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2553155
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "A_grad_1_",
    fill: "url(#A_grad_2_)",
    d: "M72.4414978,38.0511856l0.9343109-1.6426926l15.7105179-27.622757 c-0.9041977-2.5189595-2.1964951-3.6825361-4.0053253-3.6825361c-1.9381027,0-3.4884262,1.0987043-6.3311996,4.3931017 L57.0434723,46.8373146h10.4008865L72.4414978,38.0511856L72.4414978,38.0511856z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "A_solid_1_",
    fill: "#FFFFFF",
    d: "M98.0017548,7.4294395c-1.7445068-4.6515684-4.4574966-6.9129362-8.5276947-6.9129362 c-3.6824951,0-6.6539841,2.0029011-9.1738205,6.3310938l-1.5504379,2.6487041 c2.8427734-3.2943974,4.3930969-4.3931017,6.3311996-4.3931017c1.8088303,0,3.1011276,1.1635766,4.0053253,3.6825361 l7.4942627,21.7068176H76.7344131l-4.2990189,7.5586319h26.7289124l1.8093796,5.2972603 c0.839325,2.5837936,2.1316223,3.4888687,4.9099197,3.4888687h7.1056519L98.0017548,7.4294395z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "A_patch_1_",
    fill: "#FFFFFF",
    points: "76.6306458,30.4925537 72.3316193,38.0511856 72.5503311,38.0511856  76.84935,30.4925537 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N_grad_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.1557751,
    y1: 7.2922215,
    x2: 5.0423255,
    y2: 46.8290176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0681453,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2553155
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "N_grad_1_",
    fill: "url(#N_grad_2_)",
    d: "M10.0781517,46.8373337H0.000142L14.2771664,9.4962997 c1.48592-1.7444916,2.5198383-2.3901973,3.9409828-2.3901973c1.7444,0,2.9719315,1.421145,4.8450775,5.6206107 L10.0781517,46.8373337z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "N_solid_1_",
    fill: "#FFFFFF",
    d: "M23.0632267,12.7267132c-1.8731461-4.1994658-3.1006775-5.6206107-4.8450775-5.6206107 c-1.4211445,0-2.4550629,0.6457057-3.9409828,2.3901973l1.48592-3.8761191 c1.4216003-3.6825063,3.8761158-5.6206107,6.9773331-5.6206107c3.2299614,0,5.2328415,1.5507886,6.9124737,5.233295 l13.6312218,29.8463783L54.6540718,5.361701c1.0338287-2.7134542,2.2613602-3.7464759,4.3286591-3.7464759h7.1060753 L50.5194778,42.4442558C49.1632004,45.9971199,46.6433601,48,43.477726,48c-3.1006775,0-5.2328415-1.6147575-6.9123764-5.362133 L23.0632267,12.7267132z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatsOnlineFlightmarkWhiteRgb);
export default __webpack_public_path__ + "static/media/NATS_Online_Flightmark_White_RGB.aa717b2fb8219409891ddd0991017a86.svg";
export { ForwardRef as ReactComponent };